import { useQuery } from "@tanstack/react-query";
import { reservationsApi } from "../api/reservations.api";
import { accountKeys } from "../constants/query-keys";

export function useMyReservations(opts?: { enabled?: boolean }) {
  return useQuery({
    queryKey: accountKeys.reservations(),
    queryFn: reservationsApi.listMine,
    enabled: opts?.enabled,
  });
}
